<app-loader></app-loader>
<app-toolbar></app-toolbar>
<app-home></app-home>
<app-about></app-about>
<app-skills></app-skills>
<app-experiences></app-experiences>
<app-contact></app-contact>

<router-outlet></router-outlet>